import { OrderTicketEntity } from "@goodfill/domain-entities";
import { TimeInForce } from "../API";
import { isSameDay } from "@goodfill/date";

/**
 * This is HACK function till we update backend to store this propers in the order
 */
export function resolveTimeInForce(
  order: Pick<OrderTicketEntity, "isImmediate" | "createdAt" | "expiresAt">
) {
  return order.isImmediate
    ? TimeInForce.Immediate
    : isSameDay(order.createdAt, order.expiresAt)
    ? TimeInForce.CustomToday
    : TimeInForce.CustomFuture;
}
